<template>
	<div id="home-introduction">
		<!-- <div class="mobile-illustration">
			<div alt="" class="logo" />
		</div> -->
		<div class="content-container">
			<div class="content-inner">
				<div class="subtitle-wrapper">
					<div class="subtitle title headline-l" v-html="$t('homeScreen.blockChain.header')" />
				</div>
				<div class="container h-100">
					<div class="row flex-sm-row align-items-center h-100">
						<div class="col-md-7 col-lg-6 col-12 col-sm-12">
							<h1 class="title headline-l" v-html="$t('homeScreen.blockChain.title')"></h1>
							<div>
								<span class="stores-label text-l">{{
									$t('homeScreen.general.storesLabel')
								}}</span>
								<div class="stores">
									<store-button :version="'apple'" />
									<store-button :version="'google'" />
								</div>
								<!-- <div class="icons">
									<a href="https://www.facebook.com/blockbenofficial">
										<i class="bb-facebook icon" />
									</a>
									<a href="https://twitter.com/blockben?lang=en">
										<img src="/images/icons/x-white.svg" class="icon" />
									</a>
									<a href="https://www.linkedin.com/company/blockben/">
										<i class="bb-linkedin icon" />
									</a>
									<a href="https://www.youtube.com/channel/UC9SB-B1Gf50SVnerTLGIMyA">
										<i class="bb-youtube icon" />
									</a>
									<a href="https://t.me/BlockBen_Official">
										<img src="/images/icons/telegram-white.svg" class="icon" />
									</a>
								</div> -->
							</div>
						</div>
					</div>
				</div>
				<div class="introduction-image-wrapper container">
					<div class="introduction-image d-md-block" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Homeintroduction',
	props: {},
	components: {},
	data: () => ({}),
	created() { },
	computed: {},
	methods: {},
};
</script>

<style lang="scss" scoped>
#home-introduction {
	min-height: 675px;
	display: flex;
	border-bottom: 1px solid #4b2eaa80;
	background-image: url('/images/elements/home/web/home_background.png');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	flex-direction: column;
	background-color: $black;
	position: relative;

	@media (min-width: $breakpoint-sm) {


		&::before {
			content: '';
			position: absolute;
			top: auto;
			left: 0;
			right: 0;
			bottom: -2px;
			height: 133px;

			background: linear-gradient(180deg, rgba(15, 15, 116, 0) 0%, #050535 100%);

			pointer-events: none;
			z-index: 2;
		}
	}

	@media (max-width: $breakpoint-lg) {
		background-position-x: 70%;
	}

	@media (max-width: $breakpoint-sm) {
		background-image: url('/images/elements/home/mobile/home_background.png');
		background-position-x: center;
	}

	.container {
		z-index: 2;

		@media (min-width: $breakpoint-lg) {
			max-width: 1196px;
		}

		.title {
			color: $white;
			margin-bottom: $margin-m;
			text-transform: uppercase;

			@media (max-width: $breakpoint-sm) {
				text-align: center;
				font-size: 28px;
				line-height: 34px;
			}

			@media (max-width: $breakpoint-xs) {
				text-align: center;
				font-size: 28px;
				line-height: 34px;
			}

			@media (min-width: $breakpoint-lg) {
				max-width: 540px;
			}
		}

		.text {
			margin-bottom: 20px;

			@media (max-width: $breakpoint-md) {
				text-align: center;
			}

			@media (min-width: $breakpoint-lg) {
				max-width: 540px;
			}
		}
	}

	.content-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
		min-height: 675px;

		@media (max-width: $breakpoint-sm) {
			height: 100%;
			background: linear-gradient(rgba(4, 4, 40, 1),
					rgba(21, 26, 192, 0),
					rgba(13, 13, 95, 1),
					rgba(4, 4, 40, 1),
					rgba(4, 4, 40, 1));
		}

		.content-inner {
			width: 100%;
			display: flex;
			height: 100%;
			flex-direction: column;
			align-items: flex-start;
			z-index: 1;

			@media (max-width: $breakpoint-md) {
				margin-top: auto;
				margin-bottom: 40px;
			}
		}
	}

	.introduction-image-wrapper {
		position: absolute;
		justify-content: end;
		display: flex;
		margin-top: auto;
		top: 0;
		right: 0;
		height: 675px;
		z-index: 1;
		max-width: 100%;

		@media (max-width: $breakpoint-lg) {
			right: 15px;
		}

		@media (max-width: $breakpoint-md) {
			right: 15px;
		}

		@media (max-width: $breakpoint-sm) {
			position: absolute;
			justify-content: center;
			margin-top: 0;
			height: 675px;
			z-index: 1;
			right: unset;
			max-width: 100%;
			padding-right: 0px;
			padding-left: 0px;
		}
	}

	.introduction-image {
		height: 505px;
		object-fit: contain;
		margin-top: auto;
		width: 100%;
		position: relative;
		background: url('/images/elements/home/web/introduction-app-illustration.png') no-repeat bottom right;
		background-size: contain;
		right: calc(((100vw - 1196px) / 2) + 80px);

		@media (max-width: $breakpoint-lg) {
			height: 500px;
			right: calc(((100vw - 960px) / 2) + 60px);
		}

		@media (max-width: $breakpoint-md) {
			right: 15px;
		}

		@media (max-width: $breakpoint-sm) {
			margin-top: 72px;
			height: 396px;
			background: url('/images/elements/home/web/introduction-app-illustration-mobile.png') no-repeat center center;
			background-size: contain;
			right: unset;

			&::before {
				content: '';
				position: absolute;
				top: -72px;
				left: 0;
				right: 0;
				bottom: 0;
				height: 675px;
				background: linear-gradient(rgba(21, 26, 192, 0),
						rgba(21, 26, 192, 0),
						rgba(15, 15, 116, 0),
						rgba(15, 15, 116, 0.1),
						rgba(15, 15, 116, 0.2),
						rgba(15, 15, 116, 0.3),
						rgba(4, 4, 40, 0.9),
						rgba(4, 4, 40, 1),
						rgba(4, 4, 40, 1),
						rgba(4, 4, 40, 1));
				pointer-events: none;
			}
		}
	}
}

@media (max-width: $breakpoint-sm) {
	#home-introduction {
		min-height: unset !important;

		.title {
			margin-bottom: 18px !important;
		}
	}
}

.stores-label {
	color: #00dda9;
	margin: 18px 0 20px;
	display: block;
	font-family: 'HKNova-SemiBold', sans-serif;

	@media (max-width: $breakpoint-sm) {
		text-align: center;
	}
}

.icons {
	margin-top: 26px;
	line-height: $text-m;
	display: flex;
	align-items: center;

	@media (max-width: $breakpoint-sm) {
		width: 100%;
		justify-content: space-around;
	}
}

.icon {
	color: $lighter-purple;
	font-size: 20px;
	margin-right: $margin-m;

	@media (max-width: $breakpoint-md) {
		margin-right: $margin-s;
	}

	@media (max-width: $breakpoint-sm) {
		margin-right: 0px;
	}
}

.mobile-illustration {
	position: absolute;
	width: 100%;
	height: 650px;
	display: flex;
	justify-content: center;

	// background: rgba(5, 5, 51, 0.5);
	@media (min-width: $breakpoint-sm) {
		display: none;
	}
}

.logo {
	display: flex;
	margin-top: 175px;
	width: 100%;
	aspect-ratio: 363 / 51;
	height: fit-content;
	margin-left: 20px;
	margin-right: 20px;
	max-width: 420px;
	background-image: url('/images/elements/home/mobile/blockben_logo_illustration.png');
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
}

.subtitle {
	color: $white !important;
	border-radius: 4px;
	display: inline-block;
	font-family: 'HKNova-SemiBold', sans-serif;

	@media (max-width: $breakpoint-sm) {
		display: block;
		text-align: center;
		margin-left: 0;
		padding-left: 16px;
	}
}

.stores {
	display: flex;
	align-items: center;

	@media (max-width: $breakpoint-sm) {
		justify-content: center;
	}

	.store-button {
		&:first-child {
			margin-right: 20px;
		}
	}
}

.subtitle-wrapper {
	padding-left: calc(((100vw - 1196px) / 2) + 15px);
	display: flex;
	position: relative;
	background: linear-gradient(94.24deg, #080A5B 0%, #2F2FD1 100%);
	width: fit-content;
	padding-top: 20px;
	padding-bottom: 20px;
	padding-right: 20px;
	margin-bottom: 52px;
	z-index: 2;

	@media (max-width: $breakpoint-lg) {
		padding-left: calc(((100vw - 960px) / 2) + 15px);
	}

	@media (max-width: $breakpoint-md) {
		padding-left: calc(((100vw - 720px) / 2) + 15px);
	}

	@media (max-width: $breakpoint-sm) {
		z-index: 0;
		top: 0;
		position: absolute;
		width: 100%;
		justify-content: center;
		padding-top: 34px;
		padding-bottom: 24px;
		padding-right: 0px;
		padding-left: 0px;
	}

	.title {
		color: $white;
		text-transform: uppercase;

		@media (max-width: $breakpoint-sm) {
			text-align: center;
			font-size: 28px;
			line-height: 34px;
		}

		@media (max-width: $breakpoint-xs) {
			text-align: center;
			font-size: 28px;
			line-height: 34px;
		}

		@media (min-width: $breakpoint-lg) {
			max-width: 540px;
		}
	}
}
</style>
